import { openBlock as s, createElementBlock as c, createElementVNode as u, toDisplayString as x, resolveComponent as i, resolveDirective as T, withDirectives as F, createVNode as a, normalizeClass as I, Transition as S, withCtx as d, createBlock as _, Fragment as C, renderList as k, createTextVNode as O, createCommentVNode as b, vShow as z, vModelText as M } from "vue";
import { _ as g } from "./_plugin-vue_export-helper-dad06003.js";
import { C as B } from "./ChevronDownIcon-461d1eb9.js";
import { a as U, D as V, b as H } from "./DropdownDivider-c57dbbbe.js";
import { H as E } from "./CardVideo-a346405d.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import { F as N, a as R } from "./FormInputDate-84f1181a.js";
import { C as j } from "./PreloaderIcon-b44be854.js";
import { C as G } from "./ChevronLeftIcon-b6affe9b.js";
import { a as q, B as J, d as K } from "./ButtonCloseSm-209b27c6.js";
import { D as Q } from "./DotsHorizontalIcon-41c0040b.js";
import { M as W } from "./MagnifyingGlassIcon-14c73a3f.js";
import "./CheckIcon-91388c05.js";
import "./HelpIcon-2069ddad.js";
import "./ButtonPlay-d3872713.js";
import "./XIcon-e21df3cc.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./_commonjsHelpers-10dfc225.js";
import "./AlertCircleIcon-61966fff.js";
import "./MailIcon-b92e5b55.js";
import "./PhoneIcon-9b24c2d8.js";
import "./string-d21d3f3f.js";
const X = {
  name: "FilterItem",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    }
  }
}, Y = { class: "cursor-pointer flex items-center space-x-1.5 text-sm font-medium ct-text-2 select-none" }, Z = { class: "ct-text-2 pointer-events-none" }, $ = { class: "px-2 py-0.5 rounded-md ct-bg-3 ct-text-1" };
function ee(e, t, n, w, o, l) {
  return s(), c("div", Y, [
    u("p", Z, x(n.label), 1),
    u("p", $, x(n.value), 1)
  ]);
}
const A = /* @__PURE__ */ g(X, [["render", ee]]), te = {
  name: "FilterDropdown",
  components: { FilterItem: A, ChevronDownIcon: B, DropdownList: U, DropdownItem: V },
  props: {
    filter: {
      type: Object,
      default: () => {
      }
    },
    alignToRight: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select"],
  data() {
    return {
      isOpen: !1
    };
  },
  computed: {
    selectedOption() {
      return this.filter.options.find((e) => e.value === this.filter.value) || {};
    }
  },
  methods: {
    select(e, t) {
      this.$emit("select", { name: e, value: t });
    },
    hide() {
      this.isOpen = !1;
    }
  }
}, le = { class: "relative" };
function ne(e, t, n, w, o, l) {
  const f = i("FilterItem"), p = i("ChevronDownIcon"), h = i("DropdownItem"), y = i("DropdownList"), m = T("click-outside");
  return s(), c("div", le, [
    F((s(), c("div", {
      class: "cursor-pointer flex items-center space-x-1.5",
      onClick: t[0] || (t[0] = (r) => o.isOpen = !o.isOpen)
    }, [
      a(f, {
        label: n.filter.label,
        value: l.selectedOption.label
      }, null, 8, ["label", "value"]),
      a(p, {
        class: I(["h-5 w-5 ct-fg-4 transform transition-transform", [o.isOpen ? "rotate-180" : "rotate-0"]])
      }, null, 8, ["class"])
    ])), [
      [m, l.hide]
    ]),
    a(S, { name: "fade" }, {
      default: d(() => [
        o.isOpen ? (s(), _(y, {
          key: 0,
          class: I(["z-[20] absolute -bottom-2 transform translate-y-full w-64", [n.alignToRight ? "right-0" : "left-0"]])
        }, {
          default: d(() => [
            (s(!0), c(C, null, k(n.filter.options, (r) => (s(), _(h, {
              key: r.value,
              "is-selected": r.value === n.filter.value,
              onClick: (v) => l.select(n.filter.name, r.value)
            }, {
              default: d(() => [
                O(x(r.label), 1)
              ]),
              _: 2
            }, 1032, ["is-selected", "onClick"]))), 128))
          ]),
          _: 1
        }, 8, ["class"])) : b("", !0)
      ]),
      _: 1
    })
  ]);
}
const se = /* @__PURE__ */ g(te, [["render", ne]]), oe = {
  name: "FilterDate",
  components: {
    VueDatePicker: E,
    FormInputPreIcon: N
  },
  props: {
    date: {
      type: Date,
      default: null
    },
    lang: {
      type: String,
      default: "en"
    },
    title: {
      type: String,
      default: "Date"
    }
  },
  emits: ["selectCustom"],
  computed: {
    chosenDate: {
      get() {
        return this.date;
      },
      set(e) {
        this.$emit("selectCustom", e);
      }
    },
    chosenDateString() {
      return this.date ? this.date.toLocaleDateString(this.lang) : "";
    }
  }
};
function re(e, t, n, w, o, l) {
  const f = i("FormInputPreIcon"), p = i("VueDatePicker");
  return s(), _(p, {
    modelValue: l.chosenDate,
    "onUpdate:modelValue": t[0] || (t[0] = (h) => l.chosenDate = h),
    "enable-time-picker": !1,
    "action-row": { showCancel: !1, showSelect: !1, showPreview: !1 },
    "month-name-format": "long",
    locale: n.lang,
    position: "left",
    format: "dd/MM/yyyy",
    "auto-apply": ""
  }, {
    trigger: d(() => [
      a(f, {
        icon: "CalendarIcon",
        "model-value": l.chosenDateString,
        title: n.title
      }, null, 8, ["model-value", "title"])
    ]),
    _: 1
  }, 8, ["modelValue", "locale"]);
}
const mt = /* @__PURE__ */ g(oe, [["render", re]]), ie = {
  name: "FilterCalendar",
  components: {
    VueDatePicker: E,
    DropdownItem: V,
    FilterItem: A,
    ChevronDownIcon: B
  },
  props: {
    filter: {
      type: Object,
      default: () => {
      }
    },
    lang: {
      type: String,
      default: "en"
    }
  },
  emits: ["select", "selectCustom"],
  data() {
    return {
      isOpen: !1
    };
  },
  computed: {
    chosenDate: {
      get() {
        if (!this.filter.value)
          return [];
        if (this.startDate && this.endDate)
          return [this.startDate, this.endDate];
        const [e, t] = this.filter.value.split(","), n = new Date(e), w = new Date(t);
        return [n, w];
      },
      set(e) {
        this.hide(), this.$emit("selectCustom", e);
      }
    },
    filterDropdownOptions() {
      var e;
      return ((e = this.filter) == null ? void 0 : e.options) || [];
    },
    startDate() {
      var e;
      return (e = this.filter) == null ? void 0 : e.startDate;
    },
    endDate() {
      var e;
      return (e = this.filter) == null ? void 0 : e.endDate;
    },
    selectedOption() {
      return this.filter.options.find((e) => e.value === this.filter.value) || {};
    }
  },
  methods: {
    selectOption(e) {
      this.hide(), this.$emit("select", e.value);
    },
    hide() {
      this.isOpen = !1;
    }
  }
}, ae = { class: "cursor-pointer flex items-center space-x-1.5" }, ce = {
  key: 0,
  class: "w-48 flex-shrink-0"
};
function de(e, t, n, w, o, l) {
  const f = i("FilterItem"), p = i("ChevronDownIcon"), h = i("DropdownItem"), y = i("VueDatePicker");
  return s(), _(y, {
    modelValue: l.chosenDate,
    "onUpdate:modelValue": t[0] || (t[0] = (m) => l.chosenDate = m),
    range: "",
    "multi-calendars": "",
    "enable-time-picker": !1,
    "action-row": { showCancel: !1, showSelect: !1, showPreview: !1 },
    "month-name-format": "long",
    locale: n.lang,
    position: "left",
    "auto-apply": ""
  }, {
    trigger: d(() => [
      u("div", ae, [
        a(f, {
          label: n.filter.label,
          value: l.selectedOption.label
        }, null, 8, ["label", "value"]),
        a(p, {
          class: I(["h-5 w-5 ct-fg-4 transform transition-transform", [o.isOpen ? "rotate-180" : "rotate-0"]])
        }, null, 8, ["class"])
      ])
    ]),
    "left-sidebar": d(() => [
      l.filterDropdownOptions.length ? (s(), c("div", ce, [
        (s(!0), c(C, null, k(l.filterDropdownOptions, (m) => (s(), _(h, {
          key: m.value,
          "is-selected": m.value === n.filter.value,
          onClick: (r) => l.selectOption(m)
        }, {
          default: d(() => [
            O(x(m.label), 1)
          ]),
          _: 2
        }, 1032, ["is-selected", "onClick"]))), 128))
      ])) : b("", !0)
    ]),
    _: 1
  }, 8, ["modelValue", "locale"]);
}
const ue = /* @__PURE__ */ g(ie, [["render", de]]), me = {
  name: "FilterSidebar",
  components: {
    ButtonSecondaryIconSm: q,
    ChevronLeftIcon: G,
    ChevronRightIcon: j,
    ButtonCloseSm: J,
    ButtonTertiaryIconSm: K,
    DropdownItem: V,
    DropdownDivider: H,
    FormInputDate: R
  },
  props: {
    filters: {
      type: Array,
      default: () => {
      }
    },
    isSidebarOpen: {
      type: Boolean,
      default: !1
    },
    lang: {
      type: String,
      default: "en"
    }
  },
  emits: ["close", "select", "selectCustom"],
  data() {
    return {
      filterActive: {},
      startDate: null,
      endDate: null
    };
  },
  computed: {
    filtersLabel() {
      return this.lang === "en" ? "Filters" : "Filtry";
    },
    startDateLabel() {
      return this.lang === "en" ? "Start date" : "Data początkowa";
    },
    endDateLabel() {
      return this.lang === "en" ? "End date" : "Data końcowa";
    }
  },
  watch: {
    isSidebarOpen() {
      this.isSidebarOpen ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden");
    }
  },
  methods: {
    selectOption(e) {
      this.filterActive.options.forEach((t) => t.selected = !1), e.selected = !0, this.$emit("select", { name: this.filterActive.name, value: e.value }), this.clearFilterActive();
    },
    selectStartDateOption(e) {
      this.startDate = e;
      const t = this.endDate || this.getEndDate(this.filterActive.value);
      this.$emit("selectCustom", {
        name: this.filterActive.name,
        value: [new Date(this.startDate), new Date(t)]
      });
    },
    selectEndDateOption(e) {
      const t = this.startDate || this.getStartDate(this.filterActive.value);
      this.endDate = e, this.$emit("selectCustom", {
        name: this.filterActive.name,
        value: [new Date(t), new Date(this.endDate)]
      });
    },
    clearFilterActive() {
      this.filterActive = {}, this.startDate = null, this.endDate = null;
    },
    getStartDate(e) {
      return e ? e.split(",")[0] : null;
    },
    getEndDate(e) {
      return e ? e.split(",")[1] : null;
    }
  }
}, fe = {
  class: "relative z-50 lg:hidden",
  role: "dialog",
  "aria-modal": "true"
}, pe = {
  key: 0,
  class: "fixed inset-0 ct-bg-overlay"
}, _e = { class: "fixed inset-0 flex" }, he = {
  key: 0,
  class: "relative mr-16 flex w-full max-w-xs flex-1"
}, ve = {
  key: 0,
  class: "absolute left-full top-0 flex w-16 justify-center pt-5"
}, De = { class: "flex grow flex-col ct-bg-1 lg:ct-bg-2--alt overflow-y-auto" }, ge = { class: "flex-shrink-0 flex items-center h-16 ct-text-1 border-b ct-border-2" }, we = { class: "pl-3 pr-5 w-full flex items-center space-x-2" }, be = { class: "flex-grow text-base font-medium ct-text-1" }, ye = { key: 0 }, xe = ["onClick"], Ce = { class: "flex-grow text-base font-medium ct-text-1" }, Se = {
  key: 1,
  class: "mt-2"
};
function ke(e, t, n, w, o, l) {
  const f = i("ButtonCloseSm"), p = i("ChevronLeftIcon"), h = i("ButtonSecondaryIconSm"), y = i("ChevronRightIcon"), m = i("ButtonTertiaryIconSm"), r = i("DropdownItem"), v = i("DropdownDivider"), L = i("FormInputDate");
  return s(), c("div", fe, [
    a(S, { name: "fade-linear" }, {
      default: d(() => [
        n.isSidebarOpen ? (s(), c("div", pe)) : b("", !0)
      ]),
      _: 1
    }),
    a(S, { name: "pretend-transition" }, {
      default: d(() => [
        F(u("div", _e, [
          a(S, { name: "slide" }, {
            default: d(() => [
              n.isSidebarOpen ? (s(), c("div", he, [
                a(S, { name: "fade" }, {
                  default: d(() => [
                    n.isSidebarOpen ? (s(), c("div", ve, [
                      a(f, {
                        onClick: t[0] || (t[0] = (D) => e.$emit("close"))
                      })
                    ])) : b("", !0)
                  ]),
                  _: 1
                }),
                u("div", De, [
                  u("div", ge, [
                    u("div", we, [
                      o.filterActive.label ? (s(), _(h, {
                        key: 0,
                        onClick: l.clearFilterActive
                      }, {
                        default: d(() => [
                          a(p)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : b("", !0),
                      u("p", be, x(o.filterActive.label ? o.filterActive.label : l.filtersLabel), 1)
                    ])
                  ]),
                  o.filterActive.label ? (s(), c("div", Se, [
                    (s(!0), c(C, null, k(o.filterActive.options, (D) => (s(), _(r, {
                      key: D.value,
                      "is-selected": D.selected,
                      onClick: (P) => l.selectOption(D)
                    }, {
                      default: d(() => [
                        O(x(D.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["is-selected", "onClick"]))), 128)),
                    a(v),
                    a(r, null, {
                      default: d(() => [
                        o.filterActive.type === "calendar" ? (s(), _(L, {
                          key: 0,
                          "model-value": o.startDate || l.getStartDate(o.filterActive.value),
                          title: l.startDateLabel,
                          lang: n.lang,
                          "onUpdate:modelValue": l.selectStartDateOption
                        }, null, 8, ["model-value", "title", "lang", "onUpdate:modelValue"])) : b("", !0)
                      ]),
                      _: 1
                    }),
                    a(r, null, {
                      default: d(() => [
                        o.filterActive.type === "calendar" ? (s(), _(L, {
                          key: 0,
                          "model-value": o.endDate || l.getEndDate(o.filterActive.value),
                          title: l.endDateLabel,
                          lang: n.lang,
                          "onUpdate:modelValue": l.selectEndDateOption
                        }, null, 8, ["model-value", "title", "lang", "onUpdate:modelValue"])) : b("", !0)
                      ]),
                      _: 1
                    })
                  ])) : (s(), c("div", ye, [
                    (s(!0), c(C, null, k(n.filters, (D) => (s(), c("div", {
                      key: D.label,
                      class: "cursor-pointer flex items-center w-full p-2.5 space-x-2 border-b ct-border-2",
                      onClick: (P) => o.filterActive = D
                    }, [
                      u("p", Ce, x(D.label), 1),
                      a(m, null, {
                        default: d(() => [
                          a(y)
                        ]),
                        _: 1
                      })
                    ], 8, xe))), 128))
                  ]))
                ])
              ])) : b("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [z, n.isSidebarOpen]
        ])
      ]),
      _: 1
    })
  ]);
}
const Ie = /* @__PURE__ */ g(me, [["render", ke]]), Fe = {
  name: "FilterList",
  components: {
    FilterDropdown: se,
    FilterItem: A,
    DotsHorizontalIcon: Q,
    FilterSidebar: Ie,
    FilterCalendar: ue
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    lang: {
      type: String,
      default: "en"
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: ["select", "selectCustom"],
  data() {
    return {
      isOpen: !1
    };
  },
  computed: {
    notEmptyfilters() {
      return this.filters.filter((e) => e.options.length > 0);
    }
  },
  methods: {
    select(e, t) {
      this.$emit("select", { name: e, value: t });
    },
    selectCustom(e, t) {
      this.$emit("selectCustom", { name: e, value: t });
    }
  }
}, Oe = { class: "flex-grow hidden lg:flex items-center space-x-6" };
function Ve(e, t, n, w, o, l) {
  const f = i("FilterCalendar"), p = i("FilterDropdown"), h = i("FilterItem"), y = i("DotsHorizontalIcon"), m = i("FilterSidebar");
  return s(), c(C, null, [
    u("div", Oe, [
      (s(!0), c(C, null, k(l.notEmptyfilters, (r) => (s(), c("div", {
        key: r.label
      }, [
        r.type === "calendar" ? (s(), _(f, {
          key: 0,
          filter: r,
          lang: n.lang,
          onSelect: (v) => l.select(r.name, v),
          onSelectCustom: (v) => l.selectCustom(r.name, v)
        }, null, 8, ["filter", "lang", "onSelect", "onSelectCustom"])) : (s(), _(p, {
          key: 1,
          filter: r,
          onSelect: t[0] || (t[0] = (v) => l.select(v.name, v.value))
        }, null, 8, ["filter"]))
      ]))), 128))
    ]),
    u("div", {
      class: "cursor-pointer flex lg:hidden w-full items-center space-x-6 p-5",
      onClick: t[1] || (t[1] = (r) => o.isOpen = !0)
    }, [
      a(h, {
        class: "flex-grow",
        label: n.label,
        value: n.filters.length
      }, null, 8, ["label", "value"]),
      a(y, { class: "flex-shrink-0 h-5 w-5 ct-fg-4" })
    ]),
    a(m, {
      filters: n.filters,
      "is-sidebar-open": o.isOpen,
      lang: n.lang,
      onClose: t[2] || (t[2] = (r) => o.isOpen = !1),
      onSelect: t[3] || (t[3] = (r) => l.select(r.name, r.value)),
      onSelectCustom: t[4] || (t[4] = (r) => l.selectCustom(r.name, r.value))
    }, null, 8, ["filters", "is-sidebar-open", "lang"])
  ], 64);
}
const ft = /* @__PURE__ */ g(Fe, [["render", Ve]]), Ae = {
  name: "FilterSearch",
  components: {
    MagnifyingGlassIcon: W
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, Le = { class: "flex-grow flex items-center space-x-2" }, Be = ["placeholder"];
function Ee(e, t, n, w, o, l) {
  const f = i("MagnifyingGlassIcon");
  return s(), c("div", Le, [
    a(f, { class: "h-5 w-5 ct-fg-4" }),
    F(u("input", {
      "onUpdate:modelValue": t[0] || (t[0] = (p) => l.model = p),
      class: "w-full p-0 ct-text-1 text-base placeholder:ct-text-placeholder border-0 focus:border-transparent focus:ring-0 focus:outline-none bg-transparent truncate",
      placeholder: n.placeholder
    }, null, 8, Be), [
      [M, l.model]
    ])
  ]);
}
const pt = /* @__PURE__ */ g(Ae, [["render", Ee]]), Pe = {}, Te = { class: "h-6 w-px bg-gray-200 dark:bg-neutral-800" };
function ze(e, t) {
  return s(), c("div", Te);
}
const _t = /* @__PURE__ */ g(Pe, [["render", ze]]), Me = {}, Ue = {
  width: "4",
  height: "4",
  viewBox: "0 0 4 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function He(e, t) {
  return s(), c("svg", Ue, t[0] || (t[0] = [
    u("circle", {
      cx: "2",
      cy: "2",
      r: "2",
      fill: "#98A2B3"
    }, null, -1)
  ]));
}
const ht = /* @__PURE__ */ g(Me, [["render", He]]);
export {
  ue as FilterCalendar,
  mt as FilterDate,
  _t as FilterDivider,
  ht as FilterDot,
  se as FilterDropdown,
  A as FilterItem,
  ft as FilterList,
  pt as FilterSearch,
  Ie as FilterSidebar
};
